import 'babel-polyfill'
import '@/DragDropTouch'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
import VueSession from 'vue-session'
import SocialSharing from 'vue-social-sharing'
import VueLazyload from 'vue-lazyload'
import '@fortawesome/fontawesome-free/css/all.css'
import VueCookie from 'vue-cookie';


import { store } from '@/store'

import '@/directives/drag'

var options = {
  persist: true
}

Vue.use(VueCookie);
Vue.use(VueSession)
Vue.use(SocialSharing)
Vue.use(VueLazyload)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')